import { ConfigProvider } from 'antd';
import React, { Suspense } from 'react';
import { QueryClient, QueryClientProvider } from 'react-query';
import { Provider } from 'react-redux';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import './App.scss';

import { store } from './store';

import Loading from 'components/atoms/Loading';
import CodeNotFound from 'pages/CodeNotFound';
import Home from 'pages/Home';

const App: React.FC = () => (
  <Suspense fallback={<Loading width={50} variant="fullscreen" />}>
    <Routes>
      <Route path="/:code" element={<Home />} />
      <Route path="/" element={<CodeNotFound />} />
    </Routes>
  </Suspense>
);

const AppProvider: React.FC = () => {
  const queryClient = React.useRef(
    new QueryClient({
      defaultOptions: {
        queries: {
          retry: 0,
          refetchOnMount: true,
          refetchOnWindowFocus: false,
          refetchOnReconnect: false,
        },
      },
    })
  );

  return (
    <Provider store={store}>
      <QueryClientProvider client={queryClient.current}>
        <BrowserRouter>
          <ConfigProvider
            theme={{
              token: {
                colorPrimary: '#f96619',
                colorPrimaryHover: '#f96619',
                colorPrimaryActive: '#f96619',
                fontFamily: 'Open Sans',
              },
              components: {
                Button: {
                  colorPrimary: '#f96619',
                  colorPrimaryHover: '#f96619',
                  colorPrimaryActive: '#f96619',
                },
                Modal: {
                  colorPrimary: '#f96619',
                  colorPrimaryHover: '#f96619',
                  colorPrimaryActive: '#f96619',
                  colorPrimaryBg: '#f96619',
                },
              },
            }}
          // table={{
          //   className: 'tfc-table'
          // }}
          >
            <App />
          </ConfigProvider>
        </BrowserRouter>
      </QueryClientProvider>
    </Provider>
  );
};

export default AppProvider;
